import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: white;
  margin-top: 40px;
  border-radius: 10px;
  box-sizing: border-box;
`;

const H2 = styled.h2`
    position: relative !important;
    width: auto !important;
    height: auto !important;
    text-align: center !important;
    margin-top: 64px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #000 !important;
`;

const NotFound = () => (
  <Container>
    <H2>Result Not Found.</H2>
  </Container>
);

export default NotFound;
